import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, DatePicker, message, Tooltip, Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import AsyncCountrySelector from '../../commission-plan/plan-editor/asyncCountrySelector';
import TipsBox from '../tips-box';
import { dayFormatType, formatDay, moment } from '~helpers/day';
import AsyncCitySelector from './asyncCitySelector';
import AddonAfterNumberInput from './addonAfterNumberInput';
import { PAYMENT_PREFERENCE } from '~constants/referral';
const { Option } = Select;

@modal(
  {
    className: 'promotion-plan-editor-modal',
  },
  true,
)
class PromotionPlanEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comissionPlanName: props.plan?.name || '',
      externalName: props.plan?.externalName || '',
      countryCode: props.plan?.countryCode || undefined,
      currency: props.plan?.currency || '',
      defaultPlan: props.plan?.default || false,
      bookingDestinationCountryId: props.plan?.bookingDestinationCountryId || undefined,
      bookingDestinationCityIds: props.plan?.bookingDestinationCityIds || [],
      bookingDestinationCities: props.plan?.bookingDestinationCities,
      longTermCalculationValue: props.plan?.tiers[0]?.longTermCalculationValue,
      shortTermCalculationValue: props.plan?.tiers[0]?.shortTermCalculationValue,
      bookingSubmittedDateFrom: props.plan?.tiers[0]?.bookingSubmittedDateFrom
        ? moment(props.plan?.tiers[0]?.bookingSubmittedDateFrom)
        : null,
      bookingSubmittedDateTo: props.plan?.tiers[0]?.bookingSubmittedDateTo
        ? moment(props.plan?.tiers[0]?.bookingSubmittedDateTo)
        : null,
      bookingCompletedDateFrom: props.plan?.tiers[0]?.bookingCompletedDateFrom
        ? moment(props.plan?.tiers[0]?.bookingCompletedDateFrom)
        : null,
      bookingCompletedDateTo: props.plan?.tiers[0]?.bookingCompletedDateTo
        ? moment(props.plan?.tiers[0]?.bookingCompletedDateTo)
        : null,
      selectedCountry: props.plan?.bookingDestinationCountry?.slug || undefined,
      validDate: {
        validDateFrom: null,
        validDateTo: null,
      },
      paymentPreference: props.plan?.paymentPreference,
      loading: false,
    };
  }

  componentDidMount() {
    this.calcValidDate();
  }

  handleClickConfirm = () => {
    const { type } = this.props;
    if (this.state.loading) {
      return false;
    }

    this.props.form.validateFieldsAndScroll(
      // eslint-disable-next-line consistent-return
      err => {
        if (!err) {
          const params = this.props.form.getFieldsValue();

          Object.keys(params).map(key => {
            if (typeof params[key] === 'string') {
              params[key] = params[key].trim();
            }
            return true;
          });

          this.setState({ loading: true });

          if (type === 'create') {
            this.props
              .handleSubmit({
                variables: {
                  input: {
                    name: params.comissionPlanName,
                    externalName: params.externalName,
                    countryCode: params.appliedCountry,
                    currency: this.state.currency,
                    shortTermCalculationValue: params.shortTermCalculationValue,
                    longTermCalculationValue: params.longTermCalculationValue,
                    bookingDestinationCountryId: params.bookingDestinationCountryId,
                    bookingDestinationCityIds: params.bookingDestinationCityIds,
                    bookingSubmittedDateFrom: params.oppsSubmissionDate[0]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsSubmissionDate[0])
                      : null,
                    bookingSubmittedDateTo: params.oppsSubmissionDate[1]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsSubmissionDate[1])
                      : null,
                    bookingCompletedDateFrom: params.oppsCompletedDate[0]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsCompletedDate[0])
                      : null,
                    bookingCompletedDateTo: params.oppsCompletedDate[1]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsCompletedDate[1])
                      : null,
                    paymentPreference: params?.paymentPreference,
                  },
                },
              })
              .then(response => {
                if (response?.data?.createReferralCommissionPromotionPlan?.id) {
                  message.success(
                    this.props.t('cms.referral.promotion.modal.toast.success', {
                      value: this.props.t('cms.referral.promotion.modal.create_promotion.title'),
                    }),
                  );
                  this.props.handleCloseModal();
                }
              })
              .catch(error => {
                message.error(
                  error?.message
                    ? error.message
                    : this.props.t('cms.referral.promotion.modal.error.unknown'),
                );
              })
              .finally(() => {
                this.setState({ loading: false });
              });
          }

          if (type === 'edit') {
            this.props
              .handleSubmit({
                variables: {
                  input: {
                    id: this.props.plan?.id,
                    name: params.comissionPlanName,
                    externalName: params.externalName,
                    countryCode: params.appliedCountry,
                    currency: this.state.currency,
                    shortTermCalculationValue: params.shortTermCalculationValue,
                    shortTermCalculationType:
                      this.props.plan?.tiers[0].calculationRules[0].calculationType || 'VALUE',
                    longTermCalculationValue: params.longTermCalculationValue,
                    longTermCalculationType:
                      this.props.plan?.tiers[0].calculationRules[0].calculationType || 'VALUE',
                    bookingDestinationCountryId: params.bookingDestinationCountryId,
                    bookingDestinationCityIds: params.bookingDestinationCityIds,
                    bookingSubmittedDateFrom: params.oppsSubmissionDate[0]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsSubmissionDate[0])
                      : null,
                    bookingSubmittedDateTo: params.oppsSubmissionDate[1]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsSubmissionDate[1])
                      : null,
                    bookingCompletedDateFrom: params.oppsCompletedDate[0]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsCompletedDate[0])
                      : null,
                    bookingCompletedDateTo: params.oppsCompletedDate[1]
                      ? formatDay(dayFormatType.FILTERPARAMS, params.oppsCompletedDate[1])
                      : null,
                    paymentPreference: params?.paymentPreference,
                  },
                },
              })
              .then(response => {
                if (response?.data?.updateReferralCommissionPromotionPlan?.id) {
                  message.success(
                    this.props.t('cms.referral.promotion.modal.toast.success', {
                      value: this.props.t('cms.referral.promotion.modal.edit_promotion.title'),
                    }),
                  );
                  this.props.handleCloseModal();
                }
              })
              .catch(error => {
                message.error(
                  error?.message
                    ? error.message
                    : this.props.t('cms.referral.promotion.modal.error.unknown'),
                );
              })
              .finally(() => {
                this.setState({ loading: false });
              });
          }
        }
      },
    );
    return true;
  };

  handleUpdateState = (fieldName, fieldValue) => {
    this.setState(currentState => ({ ...currentState, [fieldName]: fieldValue }));
  };

  disabledDate = current => {
    // Can not select days before today and today
    if (this.props.plan?.id) {
      return false;
    } else {
      return current && current < moment().endOf('day');
    }
  };

  calcValidDate = () => {
    const params = this.props.form.getFieldsValue();

    const isSubmissionDateValid =
      params.oppsSubmissionDate.length &&
      params.oppsSubmissionDate[0] &&
      params.oppsSubmissionDate[1];

    const isOppsCompletedDateValid =
      params.oppsCompletedDate.length && params.oppsCompletedDate[0] && params.oppsCompletedDate[1];

    let selectedStartDate = null;
    let selectedEndDate = null;

    if (params.oppsSubmissionDate[0] && params.oppsCompletedDate[0]) {
      const isOpposSubmissionDateFromBeforeOppsCompleteDateFrom = moment(
        params.oppsSubmissionDate[0],
      ).isBefore(params.oppsCompletedDate[0]);
      if (isOpposSubmissionDateFromBeforeOppsCompleteDateFrom) {
        selectedStartDate = params.oppsSubmissionDate[0];
      } else {
        selectedStartDate = params.oppsCompletedDate[0];
      }
    }

    if (params.oppsSubmissionDate[1] && params.oppsCompletedDate[1]) {
      const constisOpposSubmissionDateToAfterOppsCompleteDateTo = moment(
        params.oppsSubmissionDate[1],
      ).isAfter(params.oppsCompletedDate[1]);
      if (constisOpposSubmissionDateToAfterOppsCompleteDateTo) {
        selectedEndDate = params.oppsSubmissionDate[1];
      } else {
        selectedEndDate = params.oppsCompletedDate[1];
      }
    }

    if (isSubmissionDateValid && !isOppsCompletedDateValid) {
      selectedStartDate = params.oppsSubmissionDate[0];
    }

    if (isOppsCompletedDateValid && !isSubmissionDateValid) {
      selectedStartDate = params.oppsCompletedDate[0];
    }

    this.setState({
      validDate: {
        validDateFrom: selectedStartDate,
        validDateTo: selectedEndDate,
      },
    });
  };

  validateDateDependency = source => {
    const params = this.props.form.getFieldsValue();
    let validateResult = {
      isValidate: true,
      errMsg: null,
    };

    const isSubmissionDateValid =
      params.oppsSubmissionDate.length &&
      params.oppsSubmissionDate[0] &&
      params.oppsSubmissionDate[1];

    const isOppsCompletedDateValid =
      params.oppsCompletedDate.length && params.oppsCompletedDate[0] && params.oppsCompletedDate[1];

    if (isSubmissionDateValid && isOppsCompletedDateValid) {
      const isCompleteStartDateAfterSubmissionStartDate = moment(
        params.oppsCompletedDate[0],
      ).isSameOrAfter(moment(params.oppsSubmissionDate[0]));
      if (isCompleteStartDateAfterSubmissionStartDate) {
        return validateResult;
      } else {
        validateResult = {
          isValidate: false,
          errMsg: this.props.t(
            source === 'oppsSubmissionDate'
              ? 'cms.referral.promotion.modal.error.date_picker.submission_date_start_must_before_complete_date_start'
              : 'cms.referral.promotion.modal.error.date_picker.complete_date_start_must_after_submission_date_start',
          ),
        };
        return validateResult;
      }
    } else {
      return validateResult;
    }
  };

  render() {
    const { t, type, form, partners } = this.props;
    const dateFormat = dayFormatType.FILTERPARAMS;
    const { getFieldDecorator } = form;
    const {
      comissionPlanName,
      externalName,
      countryCode,
      longTermCalculationValue,
      shortTermCalculationValue,
      bookingDestinationCountryId,
      bookingDestinationCityIds,
      bookingSubmittedDateFrom,
      bookingSubmittedDateTo,
      bookingCompletedDateFrom,
      bookingCompletedDateTo,
      bookingDestinationCities,
      paymentPreference,
    } = this.state;

    return (
      <div className="promotion-plan-editor-container">
        <div className="promotion-plan-editor-container__header">
          {t(`cms.referral.promotion.modal.${type}_promotion.title`)}
          <CloseOutlined
            className="promotion-plan-editor-container__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <div className="promotion-plan-editor-container__body">
          {partners?.length > 0 && <TipsBox partners={partners} />}
          <Form className="promotion-plan-editor__form">
            <section className="promotion-plan-editor-container__section">
              <h3 className="promotion-plan-editor-container__body__title">
                {t('cms.referral.promotion.modal.basic_info.title')}
              </h3>
              <Row gutter={40}>
                <Col span={12}>
                  <Form.Item
                    label={t('cms.referral.promotion.modal.promotion_name.label')}
                    colon={false}
                  >
                    {getFieldDecorator('comissionPlanName', {
                      rules: [
                        {
                          required: true,
                          message: t('cms.referral.promotion.modal.error.blank'),
                        },
                        {
                          whitespace: true,
                          message: t('cms.referral.promotion.modal.error.invalid'),
                        },
                        {
                          max: 255,
                          message: t('cms.referral.promotion.modal.error.promotion_name.limit'),
                        },
                        {
                          validator: (rule, value, callback) => {
                            if (value != this.props.plan?.name && value?.trim().length) {
                              this.props.handleCheckDuplicateName(value).then(res => {
                                if (res.checkReferralCommissionPlanNameExists.exists) {
                                  return callback(
                                    t(
                                      'cms.referral.commission_plan.modal.error.commission_plan_name.duplicate',
                                    ),
                                  );
                                } else {
                                  callback();
                                }
                              });
                            } else {
                              callback();
                            }
                          },
                        },
                      ],
                      initialValue: comissionPlanName,
                      validateTrigger: 'onBlur',
                    })(
                      <Input
                        autoComplete="off"
                        placeholder={t('cms.referral.promotion.modal.promotion_name.label')}
                      />,
                    )}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label={t('cms.referral.promotion.modal.external_name.label')}
                    colon={false}
                  >
                    {getFieldDecorator('externalName', {
                      rules: [
                        {
                          required: true,
                          message: t('cms.referral.promotion.modal.error.blank'),
                        },
                        {
                          max: 255,
                          message: t('cms.referral.promotion.modal.error.external_name.limit'),
                        },
                        {
                          whitespace: true,
                          message: t('cms.referral.promotion.modal.error.invalid'),
                        },
                      ],
                      initialValue: externalName,
                      validateTrigger: 'onBlur',
                    })(
                      <Input
                        placeholder={t('cms.referral.promotion.modal.external_name.label')}
                        autoComplete="off"
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={40}>
                <Col span={12}>
                  <Form.Item
                    className="promotion-plan-editor-container__body__form-item"
                    label={
                      <div className="promotion-plan-editor-container--flex">
                        {t('cms.referral.promotion.modal.applied_country.label')}
                        <Tooltip
                          title={t('cms.referral.promotion.list.tooltip.applied_country')}
                          placement="top"
                          className="promotion-plan-editor-container--ml-4"
                        >
                          <QuestionCircleOutlined className="promotion-plan-editor-container--ml-4 promotion-plan-editor-container__body__tooltip-icon" />
                        </Tooltip>
                      </div>
                    }
                    colon={false}
                  >
                    {getFieldDecorator('appliedCountry', {
                      rules: [
                        {
                          required: true,
                          message: t('cms.referral.promotion.modal.error.blank'),
                        },
                      ],
                      initialValue: countryCode,
                      validateTrigger: 'onBlur',
                    })(
                      <AsyncCountrySelector
                        disabled={partners?.length > 0}
                        onSelectCountryCurrency={v => this.setState({ currency: v })}
                        placeholder={t('cms.referral.commission_plan.modal.country.placeholder')}
                        queryCountrySlugs={['cn', 'in', 'sg', 'id', 'my', 'th']}
                      />,
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    className="promotion-plan-editor-container__body__form-item"
                    label={'Partner Payment Preference'}
                    colon={false}
                  >
                    {getFieldDecorator('paymentPreference', {
                      rules: [
                        {
                          required: true,
                          message: t('cms.referral.promotion.modal.error.blank'),
                        },
                      ],

                      initialValue: paymentPreference || 'NOT_SPECIFIC',
                    })(
                      <Select disabled={partners?.length > 0}>
                        {Object.keys(PAYMENT_PREFERENCE).map((item, index) => (
                          <Option key={index} value={item}>
                            {PAYMENT_PREFERENCE[`${item}`]}
                          </Option>
                        ))}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={40}>
                <Col span={12}>
                  <Form.Item
                    className="promotion-plan-editor-container__body__form-item"
                    label={
                      <div className="promotion-plan-editor-container--flex">
                        {t('cms.referral.promotion.modal.long_term.label')}
                        <Tooltip
                          title={t('cms.referral.promotion.list.tooltip.long_term')}
                          placement="top"
                          className="promotion-plan-editor-container--ml-4"
                        >
                          <QuestionCircleOutlined className="promotion-plan-editor-container--ml-4 promotion-plan-editor-container__body__tooltip-icon" />
                        </Tooltip>
                      </div>
                    }
                    colon={false}
                  >
                    {getFieldDecorator('longTermCalculationValue', {
                      rules: [
                        {
                          required: true,
                          message: t('cms.referral.promotion.modal.error.blank'),
                        },
                      ],
                      initialValue: longTermCalculationValue,
                      validateTrigger: 'onBlur',
                    })(
                      <AddonAfterNumberInput
                        addonAfter={this.state.currency}
                        placeholder={t('cms.referral.promotion.modal.long_term.label')}
                      />,
                    )}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    className="promotion-plan-editor-container__body__form-item"
                    label={
                      <div className="promotion-plan-editor-container--flex">
                        {t('cms.referral.promotion.modal.short_term.label')}
                        <Tooltip
                          title={t('cms.referral.promotion.list.tooltip.short_term')}
                          placement="top"
                          className="promotion-plan-editor-container--ml-4"
                        >
                          <QuestionCircleOutlined className="promotion-plan-editor-container--ml-4 promotion-plan-editor-container__body__tooltip-icon" />
                        </Tooltip>
                      </div>
                    }
                    colon={false}
                  >
                    {getFieldDecorator('shortTermCalculationValue', {
                      rules: [
                        {
                          required: true,
                          message: t('cms.referral.promotion.modal.error.blank'),
                        },
                      ],
                      initialValue: shortTermCalculationValue,
                      validateTrigger: 'onBlur',
                    })(
                      <AddonAfterNumberInput
                        addonAfter={this.state.currency}
                        placeholder={t('cms.referral.promotion.modal.short_term.label')}
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </section>

            <section className="promotion-plan-editor-container__section">
              <h3 className="promotion-plan-editor-container__body__title">
                {t('cms.referral.promotion.modal.promotion_criteria.title')}
              </h3>

              <Row gutter={16}>
                <Col span={10}>
                  <Form.Item
                    className="promotion-plan-editor-container__body__form-item"
                    label={
                      <div className="promotion-plan-editor-container--flex">
                        {t('cms.referral.promotion.modal.destination.label')}
                        <Tooltip
                          title={t('cms.referral.promotion.list.tooltip.destination')}
                          placement="top"
                          className="promotion-plan-editor-container--ml-4"
                        >
                          <QuestionCircleOutlined className="promotion-plan-editor-container--ml-4 promotion-plan-editor-container__body__tooltip-icon" />
                        </Tooltip>
                      </div>
                    }
                    colon={false}
                  >
                    {getFieldDecorator('bookingDestinationCountryId', {
                      rules: [
                        {
                          required: true,
                          message: t('cms.referral.promotion.modal.error.blank'),
                        },
                      ],
                      initialValue: bookingDestinationCountryId,
                      validateTrigger: 'onBlur',
                    })(
                      <AsyncCountrySelector
                        onSelectItem={v => {
                          if (this.state.selectedCountry !== v.node.slug) {
                            this.setState({ selectedCountry: v.node.slug });
                            form.setFieldsValue({ bookingDestinationCityIds: [] });
                          }
                        }}
                        placeholder={t('cms.referral.promotion.modal.country_selector.placeholder')}
                        type="id"
                      />,
                    )}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label=" " required={false} colon={false}>
                    {getFieldDecorator('bookingDestinationCityIds', {
                      initialValue: bookingDestinationCityIds,
                    })(
                      <AsyncCitySelector
                        disabled={!this.state.selectedCountry}
                        selectedCountry={this.state.selectedCountry}
                        placeholder={t('cms.referral.promotion.modal.city_selector.placeholder')}
                        defaultCitiesList={
                          bookingDestinationCityIds?.length ? bookingDestinationCities : []
                        }
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={40}>
                <Col span={12}>
                  <Form.Item
                    label={t('cms.referral.promotion.modal.opps_submission_date.label')}
                    colon={false}
                    required
                  >
                    {getFieldDecorator('oppsSubmissionDate', {
                      rules: [
                        {
                          validator: (rule, value, callback) => {
                            if (value?.length) {
                              if (value[0] && value[1]) {
                                const validateResult =
                                  this.validateDateDependency('oppsSubmissionDate');
                                if (validateResult.isValidate) {
                                  this.calcValidDate();
                                  callback();
                                } else {
                                  this.calcValidDate();
                                  callback(validateResult.errMsg);
                                }
                              } else {
                                this.calcValidDate();
                                callback(t('cms.referral.promotion.modal.error.blank'));
                              }
                            } else {
                              this.calcValidDate();
                              callback(t('cms.referral.promotion.modal.error.blank'));
                            }
                          },
                        },
                      ],
                      initialValue: [bookingSubmittedDateFrom, bookingSubmittedDateTo],
                    })(
                      <DatePicker.RangePicker
                        className="promotion-plan-editor-container__body__date-selector"
                        disabledDate={current => this.disabledDate(current, 'oppsSubmissionDate')}
                        format={dateFormat}
                        onChange={() => {
                          setTimeout(() => {
                            this.props.form.validateFields(['oppsCompletedDate']);
                          }, 500);
                        }}
                      />,
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={t('cms.referral.promotion.modal.opps_completed_date.label')}
                    colon={false}
                    required
                  >
                    {getFieldDecorator('oppsCompletedDate', {
                      rules: [
                        {
                          validator: (rule, value, callback) => {
                            if (value?.length) {
                              if (value[0] && value[1]) {
                                const validateResult =
                                  this.validateDateDependency('oppsCompletedDate');

                                if (validateResult.isValidate) {
                                  this.calcValidDate();
                                  callback();
                                } else {
                                  this.calcValidDate();
                                  callback(validateResult.errMsg);
                                }
                              } else {
                                this.calcValidDate();
                                callback(t('cms.referral.promotion.modal.error.blank'));
                              }
                            } else {
                              this.calcValidDate();
                              callback(t('cms.referral.promotion.modal.error.blank'));
                            }
                          },
                        },
                      ],
                      initialValue: [bookingCompletedDateFrom, bookingCompletedDateTo],
                    })(
                      <DatePicker.RangePicker
                        disabledDate={current => this.disabledDate(current, 'oppsCompletedDate')}
                        className="promotion-plan-editor-container__body__date-selector"
                        format={dateFormat}
                        onChange={() => {
                          setTimeout(() => {
                            this.props.form.validateFields(['oppsSubmissionDate']);
                          }, 500);
                        }}
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </section>
          </Form>
        </div>

        <div className="promotion-plan-editor-container__footer">
          <If condition={this.state.validDate.validDateFrom && this.state.validDate.validDateTo}>
            <span className="promotion-plan-editor-container__valid-date">
              {t('cms.referral.promotion.modal.valid_date.label', {
                value: `${formatDay(
                  dayFormatType.UKFORMAT,
                  this.state.validDate?.validDateFrom,
                )} - ${formatDay(dayFormatType.UKFORMAT, this.state.validDate?.validDateTo)}`,
              })}
            </span>
          </If>

          <Button
            ghost
            type="primary"
            size="large"
            className="promotion-plan-editor-container__cancel-button"
            onClick={this.props.handleCloseModal}
          >
            {t('cms.referral.promotion.modal.btn.cancel')}
          </Button>

          <Button
            type="primary"
            size="large"
            className="promotion-plan-editor-container__save-button"
            loading={this.state.loading}
            onClick={this.handleClickConfirm}
          >
            {t('cms.referral.promotion.modal.btn.save')}
          </Button>
        </div>
      </div>
    );
  }
}

PromotionPlanEditor.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['create', 'edit']),
  plan: PropTypes.object,
  handleCloseModal: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
    setFieldsValue: PropTypes.func.isRequired,
    validateFieldsAndScroll: PropTypes.func.isRequired,
    getFieldsValue: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleCheckDuplicateName: PropTypes.func.isRequired,
};

PromotionPlanEditor.defaultProps = {
  t: () => {},
  type: 'create',
  plan: {},
  handleCloseModal: () => {},
  form: {
    getFieldDecorator: () => {},
    setFieldsValue: () => {},
    validateFieldsAndScroll: () => {},
    getFieldsValue: () => {},
    validateFields: () => {},
  },
  handleSubmit: () => {},
  handleCheckDuplicateName: () => {},
};

export default Form.create({
  name: 'promotion_plan_editor_modal',
})(PromotionPlanEditor);
